import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../../Assets/Styles/Pages/all_blog.css';
import AboutNav from '../../Components/Navigation/AboutNav';
import Footer from '../../Components/Home/Footer';
import SEBISlider from '../../Components/Common/SEBISlider';
import ISOCertificateButton from '../../Components/Common/ISOCertificateButton';
import { Helmet } from 'react-helmet';

const All_blog = () => {
  const [activeCategory, setActiveCategory] = useState('All');

  const blogPosts = [
    {
      id: 1,
      title: "Market Analysis: Current Trends and Future Predictions",
      excerpt: "Explore the latest market trends and get insights into future market movements based on our professional analysis.",
      date: "March 15, 2024",
      category: "Market Analysis",
      image: "https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?q=80&w=2070",
      content: "Detailed content about market analysis..."
    },
    {
      id: 2,
      title: "Investment Strategies for 2024",
      excerpt: "Discover effective investment strategies tailored for the current market conditions and future opportunities.",
      date: "March 10, 2024",
      category: "Investment",
      image: "https://images.unsplash.com/photo-1590283603385-17ffb3a7f29f?q=80&w=2070",
      content: "Detailed content about investment strategies..."
    },
    {
      id: 3,
      title: "Understanding Stock Market Fundamentals",
      excerpt: "A comprehensive guide to understanding the basic principles of stock market investing and trading.",
      date: "March 5, 2024",
      category: "Education",
      image: "https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?q=80&w=2070",
      content: "Detailed content about stock market fundamentals..."
    }
  ];

  const categories = ['All', 'Market Analysis', 'Investment', 'Education'];

  const filteredPosts = activeCategory === 'All' 
    ? blogPosts 
    : blogPosts.filter(post => post.category === activeCategory);

  return (
    <>
      <Helmet>
        <title>Blog | Trillion Stock Research</title>
        <meta name="description" content="Discover the latest investment insights, market analysis, and trading strategies from Trillion Stock Research team." />
        <meta name="keywords" content="blog, stock market analysis, investment strategies, Trillion Stock Research blog" />
        <link rel="canonical" href="https://www.trillionstockresearch.com/blog" />
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "Blog",
            "name": "Trillion Stock Research Blog",
            "url": "https://www.trillionstockresearch.com/blog"
          }
        `}</script>
      </Helmet>
      <div className="trillion-all-blog-page">
        <AboutNav />
        <SEBISlider />
        <div className="trillion-blog-hero">
          <h1>Our Blog</h1>
          <p>Insights, Analysis, and Market Updates</p>
        </div>

        <div className="trillion-blog-main-container">
          <div className="trillion-blog-categories-wrapper">
            {categories.map(category => (
              <button
                key={category}
                className={`trillion-blog-category-btn ${activeCategory === category ? 'trillion-blog-category-active' : ''}`}
                onClick={() => setActiveCategory(category)}
              >
                {category}
              </button>
            ))}
          </div>

          <div className="trillion-blog-posts-grid">
            {filteredPosts.map(post => (
              <Link to={`/blog/${post.id}`} key={post.id} className="trillion-blog-post-card">
                <div className="trillion-blog-post-image-wrapper">
                  <img src={post.image} alt={post.title} className="trillion-blog-post-image" />
                  <div className="trillion-blog-post-category">{post.category}</div>
                </div>
                <div className="trillion-blog-post-content-wrapper">
                  <div className="trillion-blog-post-meta">
                    <span className="trillion-blog-post-date">{post.date}</span>
                  </div>
                  <h3 className="trillion-blog-post-title">{post.title}</h3>
                  <p className="trillion-blog-post-excerpt">{post.excerpt}</p>
                  <div className="trillion-blog-post-action">
                    <span className="trillion-blog-post-read-more">
                      Read More
                      <svg className="trillion-blog-post-arrow" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
        <Footer />
        <ISOCertificateButton />
      </div>
    </>
  );
};

export default All_blog;
